import { render, staticRenderFns } from "./StockSalesOrderMovementsTable.vue?vue&type=template&id=64012b55&scoped=true"
import script from "./StockSalesOrderMovementsTable.vue?vue&type=script&lang=js"
export * from "./StockSalesOrderMovementsTable.vue?vue&type=script&lang=js"
import style0 from "./StockSalesOrderMovementsTable.vue?vue&type=style&index=0&id=64012b55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64012b55",
  null
  
)

export default component.exports